/**
 * The AddToCartModal component
 */
import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  FaTimes,
  FaShoppingCart,
  FaCheckCircle,
  FaRegCreditCard,
  FaFileMedical,
} from "react-icons/fa";
import {
  Container,
  Row,
  Col,
  Button,
  Modal,
  Spinner,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import CheckoutModal from "./CheckoutModal";
import DataLayerHelper from "../../../utils/dataLayer";

/**
 * Stateless react component to render the AddToCartModal component
 * @param {Object} props the props passed to the page.
 */
const AddToCartModal = (props, context) => {
  const {
    language,
    addedToCart,
    addToShopCartSuccess,
    productCount,
    ctaSubtitle,
    addItemToCart,
    addToCartProcessing,
    resetCart,
    extraProducts,
    ctaTitle,
    ctaAction,
    navigateTo,
  } = props;
  const [redirectToCheckout, setRedirectToCheckout] = useState(false);
  const [redirectToCart, setRedirectToCart] = useState(false);
  const cancelSendToCheckout = (resetCartOnClose) => {
    if (resetCartOnClose === true) {
      // FIXME resetCartOnClose can be event or value passed
      if (ctaAction) {
        ctaAction();
      } else {
        resetCart();
      }
    }
    setRedirectToCheckout(false);
  };

  const sendToCheckout = () => {
    setRedirectToCheckout(true);
    DataLayerHelper.addRedirectEvent("checkout shop", "checkoutModal");
    if (navigateTo) {
      navigateTo(`/${language}/checkout/process/`);
      if (ctaAction) {
        ctaAction(false);
      } else {
        resetCart();
      }
    } else {
      window.location = `/${language}/checkout/process/`;
    }
    // setRedirectToCheckout(true)
    // if (ctaAction) { ctaAction(true); }
    // window.dataLayer = window.dataLayer || [];
    // window.dataLayer.push({
    //   'event':'redirect',
    //   'action': 'checkout select',
    //   'label': 'addToCartModal',
    //   'value': 0
    // });
  };

  const sendToCart = () => {
    setRedirectToCart(true);
    DataLayerHelper.addRedirectEvent("cart", "addToCartModal");

    if (navigateTo) {
      navigateTo(`/${language}/checkout/cart/`);
      if (ctaAction) {
        ctaAction(false);
      } else {
        resetCart();
      }
    } else {
      window.location = `/${language}/checkout/cart/`;
    }
  };

  const addExtraToCart = (extra) => {
    addItemToCart(extra);
    DataLayerHelper.addEvent(
      "upsale",
      "addToCartModal",
      extra.sku,
      extra.amount
    );
  };
  console.log(
    "addToShopCartSuccess || addToCartProcessing",
    addToShopCartSuccess,
    addToCartProcessing
  );
  return (
    <Modal
      isOpen={true}
      fade={false}
      toggle={
        !addToCartProcessing
          ? !ctaAction
            ? () => resetCart()
            : () => ctaAction()
          : null
      }
      onOpened={() => console.log(Modal.openCount, "onOpen")}
      onClosed={() => console.log(Modal.openCount, "onClosed")}
      centered
      size="lg"
    >
      <ModalHeader
        toggle={
          !addToCartProcessing
            ? !ctaAction
              ? () => resetCart()
              : () => ctaAction()
            : null
        }
      >
        {addToCartProcessing && (
          <>
            <span className="col-2">
              <Spinner size="sm" color="primary" />
            </span>
            {context.t("Adding your product to your cart.")}
          </>
        )}
        {addToShopCartSuccess && (
          <>
            <span className="col-2">
              <FaCheckCircle className="text-success" />
            </span>
            {context.t("Your product was added to your cart.")}
          </>
        )}
        {!addToCartProcessing && !(addToShopCartSuccess || addedToCart) && (
          <>
            <span className="col-2">
              <FaTimes className="text-error" />
            </span>
            {context.t("An unkown error occured")}
            <br />
            <span className="text-remark text-danger">
              {context.t(
                "Please try again. If the error persists, please contact our support and attach a screenshot: kontakt@myfolie.com."
              )}
            </span>
          </>
        )}
      </ModalHeader>

      {addToShopCartSuccess && ctaTitle && (
        <ModalBody>
          <Col xs={12} className="text-center">
            <Button
              disabled={redirectToCheckout}
              color="primary"
              className="pb-2 pt-3 border-0"
              onClick={() => {
                if (ctaAction) {
                  ctaAction();
                } else {
                  resetCart();
                }
              }}
              outline
            >
              <div
                className="rounded shadow-sm bg-light d-inline-block mr-4 pb-2 px-2 pt-1 text-secondary"
                style={{ fontSize: "2em", position: "relative", top: "-0.2em" }}
              >
                <div className="mx-2 mt-0">
                  <FaFileMedical />
                </div>
              </div>
              <div className="d-inline-block">
                <div className="text-info h5 mb-0 mt-1">{ctaTitle}</div>
                <div className="text-link">
                  {ctaSubtitle}
                  {!ctaSubtitle &&
                    context.t("Create a new product from with new settings.")}
                </div>
              </div>
            </Button>
          </Col>
        </ModalBody>
      )}

      {addToShopCartSuccess && extraProducts && (
        <ModalBody className="bg-light border-top">
          <h5>{context.t("You may be interested in...")}</h5>
          <Container>
            {extraProducts.includes("print") && (
              <Row className="py-2">
                <Col xs={3} md={2}>
                  <img
                    style={{ maxWidth: "100%", maxHeight: "60px" }}
                    src="https://cdn.myfolie.de/media/nav_vinylprint.png"
                    alt={context.t("Printed Products")}
                    title={context.t("Printed Products")}
                  />
                </Col>
                <Col xs={9} md={7}>
                  <span className="h6">
                    {context.t("Printed Products")}
                    <span className="text-success ml-1">
                      <strong>{context.t("from")} 4,95 €</strong>
                    </span>
                  </span>
                  <br />
                  <span className="small">
                    {context.t(
                      "Your design printed on one of our vinyl products such as car sticker, magnetic film or banners."
                    )}
                  </span>
                </Col>
                <Col xs={12} md={3} className="text-right">
                  <Button
                    disabled={redirectToCheckout}
                    onClick={() => {
                      navigateTo(`/${language}/eigenes-motiv/`);
                      resetCart();
                    }}
                    className="btn btn-secondary btn-sm btn-block"
                  >
                    {context.t("Explore now")}
                  </Button>
                </Col>
              </Row>
            )}

            {extraProducts.includes("text") && (
              <Row className="py-2">
                <Col xs={3} md={2}>
                  <img
                    style={{ maxWidth: "100%", maxHeight: "60px" }}
                    src="https://cdn.myfolie.de/media/nav_lettering.png"
                    alt={context.t("Adhesive Lettering")}
                    title={context.t("Adhesive Lettering")}
                  />
                </Col>
                <Col xs={9} md={7}>
                  <span className="h6">
                    {context.t("Adhesive Lettering")}
                    <span className="text-success ml-1">
                      <strong>{context.t("from")} 3,57 €</strong>
                    </span>
                  </span>
                  <br />
                  <span className="small">
                    {context.t(
                      "design individual adhesive lettering according to your customizations"
                    )}
                  </span>
                </Col>
                <Col xs={12} md={3} className="text-right">
                  <Button
                    disabled={redirectToCheckout}
                    onClick={() => {
                      navigateTo(`/${language}/klebeschriften/`);
                      resetCart();
                    }}
                    className="btn btn-secondary btn-sm btn-block"
                  >
                    {context.t("Design online")}
                  </Button>
                </Col>
              </Row>
            )}

            {extraProducts.includes("squeegee") && addItemToCart && (
              <Row className="py-2">
                <Col xs={3} md={2}>
                  <img
                    style={{ maxWidth: "60px", maxHeight: "60px" }}
                    src="https://cdn.myfolie.de/media/products/rakel_blau.jpg"
                    alt={context.t("Plastic squeegee with felt")}
                    title={context.t("Plastic squeegee with felt")}
                  />
                </Col>
                <Col xs={9} md={7}>
                  <span className="h6">
                    {context.t("Plastic squeegee with felt")}
                    <span className="text-success ml-1">
                      <strong>3,69 €</strong>
                    </span>
                  </span>
                  <br />
                  <span className="small">
                    {context.t(
                      "Installation aid for attaching the adhesive film"
                    )}
                  </span>
                </Col>
                <Col xs={12} md={3} className="text-right">
                  <Button
                    disabled={redirectToCheckout}
                    onClick={() => {
                      addExtraToCart({
                        productTitle: context.t("Plastic squeegee with felt"),
                        sku: "7004",
                        variant_id: 12177,
                        price: "3.69",
                        quantity: 1,
                      });
                    }}
                    color="secondary"
                    size="sm"
                    block
                  >
                    {context.t("Add to Cart")}
                  </Button>
                </Col>
              </Row>
            )}
          </Container>
        </ModalBody>
      )}

      {addToShopCartSuccess && (
        <ModalFooter>
          <Col xs={12} className="text-center">
            <Button
              onClick={sendToCheckout}
              disabled={redirectToCheckout || redirectToCart}
              block
              color="success"
            >
              {redirectToCheckout && (
                <>
                  <Spinner size="sm" className="mr-2" />
                  {context.t("one moment please")}
                </>
              )}
              {!redirectToCheckout && (
                <>
                  {context.t("checkout")} <FaRegCreditCard />
                </>
              )}
            </Button>
            {productCount && (
              <p className="text-center semi-small mt-1 mb-0 py-0">
                {context.t(
                  [
                    "You've got one item in your cart.",
                    "You've got {items} items in your cart.",
                    "single",
                  ],
                  { items: productCount, single: productCount === 1 }
                )}
              </p>
            )}
            {!redirectToCart && !redirectToCheckout && (
              <Button
                onClick={sendToCart}
                color="primary"
                size="sm"
                outline
                className="border-0"
              >
                <FaShoppingCart /> {context.t("View Cart")}
              </Button>
            )}
            {redirectToCart && (
              <span className="text-secondary d-block">
                <Spinner size="sm" className="mr-2" />
                {context.t("one moment please")}
              </span>
            )}
          </Col>
        </ModalFooter>
      )}
      {redirectToCheckout && (
        <CheckoutModal
          language={language}
          onClose={cancelSendToCheckout}
          navigateTo={navigateTo}
        />
      )}
    </Modal>
  );
};

/** define proptypes for the form */
AddToCartModal.propTypes = {
  addingToCart: PropTypes.bool.isRequired,
  addedToCart: PropTypes.bool.isRequired,
  addToShopCartSuccess: PropTypes.bool.isRequired,
  addToCartProcessing: PropTypes.bool.isRequired,
  resetCart: PropTypes.func.isRequired,
  language: PropTypes.string.isRequired,
  extraProducts: PropTypes.array,
  ctaTitle: PropTypes.string,
  ctaSubtitle: PropTypes.string,
  productCount: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
  ctaAction: PropTypes.func,
  addItemToCart: PropTypes.func,
};

/**  define proptype for the 'translation' function  */
AddToCartModal.contextTypes = {
  t: PropTypes.func,
};
export default AddToCartModal;
